import React from 'react';
import cls from './information.module.scss';
import { Card, Container } from '@material-ui/core';
import HelmetComponent from '../../components/HelmetComponent';
import { useTranslation } from 'react-i18next';
import CompanyMail from '../../components/CompanyMail';

const Mail = ({language}) => {
    const { t } = useTranslation();
    return (
        <main className={cls.information_container}>
            <HelmetComponent titlePage={t('helmet.mail.title',{ lng: language })} description={t('helmet.mail.description',{ lng: language })} title={t('helmet.mail.title',{ lng: language })} keywords={t('helmet.mail.keywords',{ lng: language })} />
            <div style={{ position: 'relative' }}>
                <Container component="main" maxWidth="lg">
                    {/* </Container> */}
                    <Card className={cls.information_block_card}>
                        <CompanyMail language={language}/>
                    </Card>
                </Container>
            </div>
        </main>)
};

export default Mail;